import { cn } from "@/utils/cn";
import { PlaygroundSidebar } from "./playground-sidebar";
import { PlaygroundMain } from "./playground-main";

const PlaygroundLayout = ({
  singleRenderedChildren = false,
}: {
  singleRenderedChildren: boolean;
}) => {
  return (
    <div
      className={cn("flex relative w-full overflow-hidden", {
        "min-h-screen max-h-screen": singleRenderedChildren,
        "h-full": !singleRenderedChildren,
        "p-2 md:p-8": !singleRenderedChildren,
      })}
    >
      <PlaygroundSidebar />
      <PlaygroundMain />
    </div>
  );
};
export { PlaygroundLayout };
